import { Button, Dropdown } from 'react-bootstrap';
import classNames from 'classnames/bind';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons/faCheckSquare';
import { faSquare } from '@fortawesome/pro-light-svg-icons/faSquare';
import { faLongArrowRight } from '@fortawesome/pro-light-svg-icons/faLongArrowRight';

import { allFilters } from '../../../../data/filters/storyFilters';
import { getFilterValues } from '../../../../helpers/helpers';
import Styles from './styles.module.scss';
import Preloader from '../../../Preloader';

const cx = classNames.bind(Styles);
const FilterInner = ({
  differentFiltersValues,
  selectAllStatus,
  selectAll,
  handleFilterChange,
  selectStatus,
  cancel,
  reset,
  isLoading,
}) => {
  const getName = (filter) => allFilters[0][filter];

  const accessLevels = useSelector(({ subscriptions }) => subscriptions.permissions.access_levels);

  return (
    <div className={cx('reset_filter_menu')}>
      <div className={Styles.filter_title_holder}>
        <div className={Styles.filter_title}>
          Reset Filters and Settings
          <p>Select which settings to reset to default</p>
        </div>
      </div>
      {isLoading ? <Preloader centered loading static /> : (
        differentFiltersValues.length > 0 && (
          <div className={cx('categories_options')}>
            <Dropdown.Item
              active={selectAllStatus}
              onClick={selectAll}
              disabled={!differentFiltersValues.length}
            >
              <FontAwesomeIcon icon={selectAllStatus ? faCheckSquare : faSquare} />
              <div className={Styles.reset_filter_container}>
                <div className={Styles.filter_title}>Select / Unselect All</div>
                <div className={Styles.filter_value_container}>
                  <div className={Styles.current_title}>Reset from</div>
                  <div className={Styles.reset_title}>Reset to</div>
                </div>
              </div>
            </Dropdown.Item>
            {differentFiltersValues.map((filter, index) => (
              <div key={filter.key}>
                <Dropdown.Item
                  active={filter.select}
                  onSelect={() => handleFilterChange(filter.key)}
                >
                  <FontAwesomeIcon icon={filter.select ? faCheckSquare : faSquare} />
                  <div className={Styles.reset_filter_container}>
                    <div className={Styles.filter_value}>
                      {getName(filter.key, filter.currentValue, accessLevels)}
                    </div>
                    <div className={Styles.filter_value_container}>
                      <div className={Styles.current_value}>
                        {getFilterValues(filter.key, filter.currentValue, accessLevels, false)}
                      </div>
                      <div className={Styles.arrow}>
                        <FontAwesomeIcon icon={faLongArrowRight} />
                      </div>
                      <div className={Styles.reset_value}>
                        {getFilterValues(filter.key, filter.resetValue, accessLevels, true)}
                      </div>
                    </div>
                  </div>
                </Dropdown.Item>
                {(index !== (differentFiltersValues.length - 1)) && <Dropdown.Divider />}
              </div>
            ))}
            <div className={cx('reset-filter-btn--container')}>
              <Button
                className={cx('story-filters_btn--cancel')}
                onClick={cancel}
                variant="default"
              >
                Cancel
              </Button>
              <Button
                className={cx('story-filters_btn--reset', { selected: selectStatus })}
                onClick={reset}
                variant="default"
                disabled={!selectStatus}
              >
                Reset
              </Button>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default FilterInner;
